import {
    UPLOADSAMPLEFILEOFDEALERDSRLIMIT_SUCCESS,
    UPLOADSAMPLEFILEOFDEALERDSRLIMIT_FAILED,
    RESET_UPLOADSAMPLEFILEOFDEALERDSRLIMIT,
    LOADING_UPLOADSAMPLEFILEOFDEALERDSRLIMIT,
    NETWORK_ERROR_UPLOADSAMPLEFILEOFDEALERDSRLIMIT
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPLOADSAMPLEFILEOFDEALERDSRLIMIT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPLOADSAMPLEFILEOFDEALERDSRLIMIT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPLOADSAMPLEFILEOFDEALERDSRLIMIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPLOADSAMPLEFILEOFDEALERDSRLIMIT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPLOADSAMPLEFILEOFDEALERDSRLIMIT:
            return (state = initialState);
        default:
            return state;
    }
};